/**
 * FBSBancaSUMAK
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ContactoComplementoModeloMS } from './contactoComplementoModeloMS';

export interface ObtenerContactoMS { 
    id?: number;
    tipoIdentificacionId?: number;
    tipoIdentificacionDescripcion?: string;
    nombre?: string;
    numeroCuenta?: string;
    identificacion?: string;
    correoElectronico?: string;
    telefono?: string;
    esInterno?: boolean;
    estaActivo?: boolean;
    contactoComplemento?: ContactoComplementoModeloMS;
}